// client/src/routes/app/properties/$propertyId/contracts.tsx — SCR-PROP-003 tab „Contracte și
// chiriași" (D-2840).
//
// SCR-CON-001's list with the property pinned: every contract the apartment has had, drafts,
// the one in force and the ones that ended, each with the tenants who signed it — which is where
// a landlord finds the tenants who have left. The URL state is the list's own schema, so a
// filtered tab is shareable exactly as the list is; `propertyId` in it is ignored, the route's
// parameter wins. `Leasing.Read` on top of the layout's `Portfolio.Read`, as the list's route.

import { createFileRoute, useNavigate } from '@tanstack/react-router';

import { RequirePermission } from '@/components/layout/route-guards';
import { ContractList } from '@/features/contracts/ContractList';
import { contractSearchSchema, type ContractSearch } from '@/features/contracts/search';

export const Route = createFileRoute('/app/properties/$propertyId/contracts')({
  validateSearch: contractSearchSchema,
  component: ContractListTab,
});

function ContractListTab() {
  const { propertyId } = Route.useParams();
  const search = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });

  return (
    <RequirePermission permission="Leasing.Read">
      <ContractList
        pinnedPropertyId={propertyId}
        search={search}
        onSearchChange={(next: (previous: ContractSearch) => ContractSearch) => {
          void navigate({ search: next });
        }}
      />
    </RequirePermission>
  );
}
